import React from 'react';
import { HStack, Icon, Text } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { PillTone, pillTones } from '../theme';

type Props = {
  label: string;
  tone: PillTone;
  icon?: IconType;
};

/** Status pill used for claim / proposal states across the feature (board: 28px, 12px/800). */
const Pill: React.FC<Props> = ({ label, tone, icon }) => {
  const { bg, color, boxShadow } = pillTones[tone];
  return (
    <HStack
      as="span"
      display="inline-flex"
      spacing="4px"
      flex="none"
      h="28px"
      px="10px"
      fontSize="12px"
      fontWeight={600}
      borderRadius="full"
      bg={bg}
      color={color}
      boxShadow={boxShadow}
      whiteSpace="nowrap"
    >
      {icon && <Icon as={icon} boxSize="12px" />}
      <Text as="span">{label}</Text>
    </HStack>
  );
};

export default Pill;
